import { FC, useCallback } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import {
  IPolotnoTemplatesProps,
  PolotnoTemplates,
} from "@/components/features/polotno_templates";

export const Templates: FC<Pick<IPolotnoTemplatesProps, "pathPattern">> = ({
  pathPattern,
}) => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleCreateNew = useCallback<
    IPolotnoTemplatesProps["onCreateNew"]
  >(() => {
    navigate("/polotno/designs/templates", {
      state: { prevPath: location.pathname },
    });
  }, [location.pathname, navigate]);

  const handleOpen = useCallback<IPolotnoTemplatesProps["onOpen"]>(
    (templateDataString) => {
      navigate(`/polotno/templates/${templateDataString}`, {
        state: {
          prevPath: location.pathname,
        },
      });
    },
    [location.pathname, navigate],
  );

  return (
    <PolotnoTemplates
      pathPattern={pathPattern}
      onOpen={handleOpen}
      onCreateNew={handleCreateNew}
    />
  );
};
